import React from 'react';

import Page from 'components/page';
import AboutPageIntro from 'components/aboutPageIntro';
import ScrollTabs from 'components/scrollTabs';
import Mission from 'components/mission';
import RoadMap from 'components/roadMap';
import Milestones from 'components/milestones';
import Team from 'components/team';

const tabs = [
  {
    title: 'Mission & Vision',
    render: Mission,
  },
  {
    title: 'Company',
    render: Milestones,
  },
  {
    title: 'Process',
    render: RoadMap,
  },
  {
    title: 'Leadership',
    render: Team,
  },
];

const About = ({ location: { hash } }) => (
  <Page pageName="about">
    <AboutPageIntro />
    <ScrollTabs tabs={tabs} defaultTab={hash.replace(/#/g, '')} />
  </Page>
);

export default About;
